import { Close } from "components/assets/Icons";
import UserInfo from "components/UserInfo";
import { forwardRef } from "react";
import { getZonedTime, SYSTEM_TIMEZONE } from "utils/trackingTransform";
import styles from "./Popup.module.scss";
import { createEmailsField } from "pages/Tracking/utils";
import Button, { SIZE } from "components/Button";
import userService from "services/user.service";

const Popup = forwardRef((props, ref) => {
  const {
    data,
    setShowPopup,
    setHidden,
    setActiveRow,
    setShowDetailPopup,
    setPopupDetails,
    timezone = SYSTEM_TIMEZONE,
  } = props || {};
  const { photos, info, groupIndex, currentData, position } = data || {};
  const currentInfo = info && Object.values(info)[groupIndex];
  const tzTime = (ts) => getZonedTime(ts, timezone);

  const closeHandler = () => {
    setShowPopup(false);
    setHidden(false);
    setActiveRow();
  };

  const handleClick = () => {
    userService.getPopupDetails(currentData?.gmail_id).then(
      (response) => {
        const allData = Object.assign(response?.data, {
          photoUrl: photos[Object.keys(info)[groupIndex]],
          firstName: currentInfo?.first_name,
          lastName: currentInfo?.last_name,
        });

        setPopupDetails(allData);
        setShowDetailPopup(true);
      },
      (error) => {
        const _content =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();

        setPopupDetails(_content);
      }
    );
  };

  return (
    <div
      ref={ref}
      className={styles.wrapper}
      style={{
        top: position,
      }}
    >
      <span className={styles.close} onClick={closeHandler}>
        <Close />
      </span>
      <div className={styles.header}>
        <div className={styles.user}>
          {info && (
            <UserInfo
              src={photos[Object.keys(info)[groupIndex]]}
              name={`${currentInfo?.first_name} ${currentInfo?.last_name}`}
            />
          )}
        </div>
      </div>
      <div className={styles.body}>
        <div className={styles.popup_title}>
          {currentData?.event_type === "chat_bid"
            ? "Chat Bid"
            : currentInfo?.is_incoming === "inbound"
            ? "Incoming Call"
            : currentInfo?.is_incoming === "outbound"
            ? "Outgoing Call"
            : "Outgoing Email"}
        </div>
        <div className={styles.popup_table}>
          {currentData?.call_date_time ? (
            <>
              <span className={styles.popup_label}>Start:</span>
              <span className={styles.popup_value}>
                {tzTime(currentData?.call_date_time)}
              </span>
            </>
          ) : (
            ""
          )}
          {currentData?.call_date_time_end ? (
            <>
              <span className={styles.popup_label}>End:</span>
              <span className={styles.popup_value}>
                {tzTime(currentData?.call_date_time_end)}
              </span>
            </>
          ) : (
            ""
          )}
          {currentData?.duration ? (
            <>
              <span className={styles.popup_label}>Duration:</span>
              <span className={styles.popup_value}>
                {currentData?.duration}
              </span>
            </>
          ) : (
            ""
          )}
          {currentData?.sent_date ? (
            <>
              <span className={styles.popup_label}>Time Sent</span>
              <span className={styles.popup_value}>
                {tzTime(currentData?.sent_date)}
              </span>
            </>
          ) : (
            ""
          )}
          {currentData?.email_from ? (
            <>
              <span className={styles.popup_label}>From</span>
              <span className={styles.popup_value}>
                {createEmailsField(currentData?.email_from, true)}
              </span>
            </>
          ) : (
            ""
          )}
          {currentData?.email_to ? (
            <>
              <span className={styles.popup_label}>To</span>
              <span className={styles.popup_value}>
                {createEmailsField(currentData?.email_to, true)}
              </span>
            </>
          ) : (
            ""
          )}
          {currentData?.email_cc !== undefined ? (
            <>
              <span className={styles.popup_label}>CC</span>
              <span className={styles.popup_value}>
                {currentData?.email_cc
                  ? createEmailsField(currentData?.email_cc, true)
                  : "—"}
              </span>
            </>
          ) : (
            ""
          )}
          {currentData?.email_bcc !== undefined ? (
            <>
              <span className={styles.popup_label}>BCC</span>
              <span className={styles.popup_value}>
                {currentData?.email_bcc
                  ? createEmailsField(currentData?.email_bcc, true)
                  : "—"}
              </span>
            </>
          ) : (
            ""
          )}

          {currentData?.subject ? (
            <>
              <span className={styles.popup_label}>Subject</span>
              <span className={styles.popup_value}>{currentData?.subject}</span>
            </>
          ) : (
            ""
          )}
          {currentData?.event_type === "chat_bid" && currentData?.message ? (
            <>
              <span className={styles.popup_label}>Message</span>
              <span className={styles.popup_value}>{currentData?.message}</span>
            </>
          ) : (
            ""
          )}
        </div>
        {currentData?.destination_or_caller ? (
          <div className={styles.info}>
            <span className={styles.popup_label}>
              {currentData?.is_incoming === "inbound"
                ? "Caller:"
                : "Destination:"}
            </span>
            <span className={styles.popup_value}>
              {currentData?.destination_or_caller}
            </span>
          </div>
        ) : (
          ""
        )}
        {currentData?.gmail_id ? (
          <Button
            size={SIZE.SMALL}
            className={styles.button}
            onClick={handleClick}
          >
            View
          </Button>
        ) : (
          ""
        )}
      </div>
    </div>
  );
});

export default Popup;
